// External dependencies
import { ofType } from 'redux-observable';
import { Observable, switchMap } from 'rxjs';

// Local dependencies
import { getClient } from '../../../../../clients/demirbank';
import { getCategoryError, getCategorySuccess } from './actions';
import { getCategoryQuery } from './queries';
import { GetCategory, GetCategoryAction, GetCategoryActionType, GetCategoryInput } from './types';

export function getCategoryEpic(action$: Observable<GetCategoryAction>) {
  return action$.pipe(
    ofType(GetCategoryActionType.GET_CATEGORY),
    switchMap((action: GetCategory) => getCategory(action.input).then(getCategorySuccess).catch(getCategoryError)),
  );
}

async function getCategory(input: GetCategoryInput) {
  const graphQLClient = await getClient();

  const {
    data: { getCategory },
  } = await graphQLClient.query({
    query: getCategoryQuery,
    variables: { input },
  });

  let tags = [];
  if (getCategory?.tags) {
    const tagsPromises = getCategory?.tags
      ?.filter((tag) => tag !== 'kyrgyzstan')
      .map((tagId) => {
        return graphQLClient.query({
          query: getCategoryQuery,
          variables: {
            input: { id: tagId },
          },
        });
      });

    tags = (await Promise.all(tagsPromises)).map((item) => {
      const { id, name_en, name_ru, name_ky, name_tr } = item.data.getCategory;

      return { id, name_en, name_ru, name_ky, name_tr };
    });
  }

  return { ...getCategory, tags };
}
